var _defs, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 98.8 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#efefef;}.cls-2{fill:#fefefe;stroke:#efefef;stroke-miterlimit:10;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ship") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.09,51.46H97.17c.29,0,.58,0,.86,0a1.42,1.42,0,0,1,1.18,2.26c-2.34,4.25-4.7,8.5-7,12.76a30.08,30.08,0,0,1-4.45,6.23,28.68,28.68,0,0,1-19.58,9.19C67,82,65.89,82,64.77,82H16.12c-4,0-6.54-1.84-7.79-5.64-.34-1.07-.69-2.14-1-3.2Q4.09,63.55.87,53.92c-.56-1.68,0-2.46,1.82-2.46Z",
    transform: "translate(-0.66 -18)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,36.91c-1.49,0-3,0-4.47,0-.44,0-.57-.12-.57-.57,0-3,0-6,0-9,0-.5.16-.6.62-.6q4.47,0,8.94,0c.47,0,.64.13.63.62q0,4.47,0,8.94c0,.56-.21.64-.69.63C27,36.89,25.46,36.91,24,36.91Z",
    transform: "translate(-0.66 -18)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,23.83c-1.49,0-3,0-4.46,0-.43,0-.6-.1-.59-.56,0-1.57,0-3.14,0-4.7,0-.44.11-.58.57-.58,3,0,6,0,9,0,.42,0,.62.08.61.56,0,1.57,0,3.13,0,4.7,0,.46-.16.58-.59.57C27,23.81,25.5,23.83,24,23.83Z",
    transform: "translate(-0.66 -18)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.87,61.16A2.8,2.8,0,0,1,48.58,64,2.82,2.82,0,1,1,43,63.9,2.81,2.81,0,0,1,45.87,61.16Z",
    transform: "translate(-0.66 -18)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.93,64a2.8,2.8,0,1,1-5.6-.11,2.8,2.8,0,1,1,5.6.11Z",
    transform: "translate(-0.66 -18)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.06,49.94H12.24a.58.58,0,0,1-.57-.58V39.88a1.52,1.52,0,0,1,1.51-1.51H44.12A2.07,2.07,0,0,1,46,39.54l4.62,9.53A.6.6,0,0,1,50.06,49.94Z",
    transform: "translate(-0.66 -18)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip);
export default __webpack_public_path__ + "static/media/ship.3b67bbaf50958c9db9bb87a70c20790b.svg";
export { ForwardRef as ReactComponent };